import { Navigate, useLocation } from 'react-router-dom';

/**
 * Unified auth: /sign-up redirects to /sign-in preserving query params.
 * The sign-in form handles both new and existing accounts.
 */
export function SignUpPage() {
  const location = useLocation();
  return <Navigate to={`/sign-in${location.search}`} replace />;
}
